import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
    Grid, Card, TextField, Button, Dialog, DialogActions, DialogContent,
    FormHelperText, Alert, Radio, RadioGroup, FormControlLabel
} from "@mui/material/";
import Select from "react-select";
import { PhoneSearchAPI } from "API/PhoneSearchAPI";
import { QueryAPI } from "API/QueryAPI";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { style } from "style";
import { checkResponse, alertWarningText } from "helpers/notification";
import DatePicker from "react-multi-date-picker";
import moment from 'moment';
import { multiSelectStyles } from "style";
import { useNavigate } from "react-router-dom";
import { endDateControl } from "helpers/helper";
import gregorian_tr from "helpers/gregorian_tr";
import weekends from "react-multi-date-picker/plugins/highlight_weekends";
import AsyncSelect from "react-select/async";
import debounce from "lodash.debounce";

function PhoneSearch() {
    let date = new Date();

    var groupId = useSelector(state => state.common.groupId);
    var userName = useSelector(state => state.common.userName);

    const loadOptions = (inputValue, callback) => {
        if (isAllUsersSelected) {
            callback([{ value: "*", label: "Tüm Kullanıcılar" }]);
            return;
        }

        const searchText = (inputValue || "").toLowerCase().trim();

        if (searchText.length < 2) {
            callback(defaultSenderOptions);
            return;
        }

        const filteredOptions = defaultSenderOptions.filter(option =>
            option.label.toLowerCase().includes(searchText)
        );

        callback(filteredOptions);
    };


    const [startDate, setStartDate] = useState(date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + " 00:00:00");
    const [endDate, setEndDate] = useState(date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + " 23:59:59");

    const [userEuIdOptions, setUserEuIdOptions] = useState([]);
    const [userEuIdData, setUserEuIdData] = useState([]);

    const [msgContent, setMsgContent] = useState("");
    const [msgContentDialogOpen, setMsgContentDialogOpen] = useState(false);

    const [userEuIdSelectedOptions, setUserEuIdSelectedOptions] = useState([]);
    const [phoneNumbersText, setphoneNumbersText] = useState(['']);
    const [phoneNumbers, setphoneNumbers] = useState(['']);
    const startDateISO = moment(startDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    const endDateISO = moment(endDateControl(endDate)).format('YYYY-MM-DDTHH:mm:ss.SSSZ');

    const maxDate = new Date();
    const minDate = new Date();
    minDate.setMonth(minDate.getMonth() - 3);

    const validateDateRange = (startDate, endDate) => {
        const minDateISO = moment(minDate).format('YYYY-MM-DD');
        return !(moment(startDate).format('YYYY-MM-DD') < minDateISO) && !(moment(endDate).format('YYYY-MM-DD') < minDateISO);
    }
    const [queryId, setQueryId] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState("");

    const [queryName, setQueryName] = useState("");

    const [numberType, setNumberType] = useState("yurtici");
    const [phoneHelperText, setPhoneHelperText] = useState("Yurt içi telefon numaralarını 5xxxxxxxxx formatında yazabilirsiniz. Birden fazla numara girmek için numaraları alt alta (her satıra bir numara) yazabilirsiniz.");
    const [phoneLabel, setPhoneLabel] = useState("Telefon");

    const isAllUsersSelected = userEuIdSelectedOptions.some(i => i.value === "*");

    const navigate = useNavigate();

    const handleUserEuIdChange = (options) => {
        const selected = options || [];

        if (selected.some(i => i.value === "*")) {
            setUserEuIdSelectedOptions([{ value: "*", label: "Tüm Kullanıcılar" }]);
            return;
        }

        setUserEuIdSelectedOptions(selected);
    };

    function selectedUsers(userList) {
        let tempArr = [];

        userList.map(id => {
            tempArr.push({
                userEuId: id.value,
                loginName: id.label
            });
        });

        return tempArr;
    }

    const handlePhoneChange = event => {
        setphoneNumbersText(event.target.value);
        setphoneNumbers(event.target.value.split(/\s+/));
    };

    const insertQuery = async e => {

        if (!validateDateRange(startDate, endDate)) {
            alertWarningText("Lütfen son üç ay içinde geçerli bir tarih aralığı seçiniz.");
            return;
        }
        if (startDate > endDate) {
            alertWarningText("Lütfen geçerli bir tarih aralığı seçiniz.Bitiş tarihi başlangıç tarihinden küçük olamaz");
            return;
        }

        if (userEuIdSelectedOptions.length === 0) {
            return alertWarningText("Lütfen en az bir adet kullanıcı seçiniz!");
        }

        let userEuIds = userEuIdSelectedOptions.some(i => i.value === '*') ? selectedUsers(userEuIdData) : selectedUsers(userEuIdSelectedOptions);

        if (phoneNumbers.length === 1 && phoneNumbers[0] === "") {
            return alertWarningText("Lütfen en az bir adet numara giriniz!");
        }
        const isNumberValid = validateNumbers(numberType, phoneNumbers);
        if (!isNumberValid) return;

        userEuIds.sort((a, b) => {
            if (a.loginName < b.loginName) return -1;
            if (a.loginName > b.loginName) return 1;
            return 0;
        });

        let parameters = {
            loginName: JSON.stringify(userEuIds),
            phones: JSON.stringify(phoneNumbers),
            startDate: startDateISO,
            endDate: endDateISO,
            numberType: numberType
        }

        const isExistQueryResponse = await QueryAPI.IsExistQuery("phonesearch", userName, parameters);
        if (isExistQueryResponse.data.resultObject.isExist) {
            alertWarningText("Talep ettiğiniz sorgu " + isExistQueryResponse.data.resultObject.queryId + " id si ile zaten var. Lütfen sorgular menüsündeki listeden kontrol ediniz.");
            return;
        }

        const insertQueryResponse = await QueryAPI.InsertQuery(
            userName,
            0,
            "phonesearch",
            queryName,
            new Date(),
            parameters
        );
        if (
            checkResponse(
                insertQueryResponse,
                null,
                "Numara Sorgu Raporu getirme işlemi başarısız oldu.Lütfen Tekrar deneyin."
            )
        ) {
            if (insertQueryResponse.data.resultObject !== "") {
                setQueryId(insertQueryResponse.data.resultObject);
                setShowAlert(true);
                setAlertType("success");
            }
        }
    };

    const handleNumberTypeChange = event => {

        setNumberType(event.target.value);

        switch (event.target.value) {
            case "yurtdisi":
                setPhoneHelperText("Telefon numarasını 90xxxxxxxxxx ( {ülke kodu}xxxxxxxxxx ) formatında giriniz. + ve 00 ile başlayan numaralar kabul edilmez. Birden fazla numara girmek için numaraları alt alta (her satıra bir numara) yazabilirsiniz.");
                setPhoneLabel("Telefon");
                break;
            case "tckn":
                setPhoneHelperText("11 haneli TCKN’leri 111xxxxxxxx formatında giriniz. Birden fazla TCKN için alt alta (her satıra bir tckn) yazabilirsiniz.");
                setPhoneLabel("Tckn");
                break;
            default:
                setPhoneHelperText("Yurt içi telefon numaralarını 5xxxxxxxxx formatında yazabilirsiniz. Birden fazla numara girmek için numaraları alt alta (her satıra bir numara) yazabilirsiniz.");
                setPhoneLabel("Telefon");
                break;
        }
    };

    const validateNumbers = (numberType, phoneNumbers) => {
        for (let i = 0; i < phoneNumbers.length; i++) {
            const value = phoneNumbers[i].trim();
            const lineNumber = i + 1;

            if (!value) {
                return alertWarningText(
                    `${lineNumber}. satır boş bırakılamaz. Her satıra bir değer giriniz.`
                );
            }

            if (numberType === "yurtici") {
                if (
                    !/^\d+$/.test(value) ||
                    value.length !== 10 ||
                    value[0] !== "5"
                ) {
                    return alertWarningText(
                        `${lineNumber}. satır hatalı. Yurt içi telefon numaralarını 5xxxxxxxxx formatında giriniz.`
                    );
                }
            }

            if (numberType === "yurtdisi") {
                if (
                    !/^\d+$/.test(value) ||
                    value.startsWith("+") ||
                    value.startsWith("00") ||
                    value.length < 10 ||
                    value.length > 15
                ) {
                    return alertWarningText(
                        `${lineNumber}. satır hatalı. Telefon numarasını {ülke kodu}xxxxxxxxxx formatında giriniz. + ve 00 ile başlayan numaralar kabul edilmez.`
                    );
                }
            }

            if (numberType === "tckn") {
                if (
                    !/^\d+$/.test(value) ||
                    value.length !== 11
                ) {
                    return alertWarningText(
                        `${lineNumber}. satır hatalı. 11 haneli TCKN’leri 111xxxxxxxx formatında giriniz.`
                    );
                }
            }
        }

        return true;
    };

    const [defaultSenderOptions, setDefaultSenderOptions] = useState([]);

    const getSenderList = async () => {
        if (Number(groupId) === -1) {
            const response = await PhoneSearchAPI.GetUserEuIdByLoginName(userName);

            if (
                checkResponse(
                    response,
                    null,
                    "Kullanıcı bilgisi getirme işlemi başarısız oldu.Lütfen Tekrar deneyin."
                )
            ) {
                const currentUser = response?.data?.resultObject?.[0];

                if (currentUser) {
                    const option = {
                        value: currentUser.userEuId,
                        label: currentUser.loginName
                    };

                    setUserEuIdData([option]);
                    setUserEuIdSelectedOptions([option]);
                    setDefaultSenderOptions([{ value: "*", label: "Tüm Kullanıcılar" }, option]);
                }
            }

            return;
        }

        const response = await PhoneSearchAPI.GetUserGroupRelatedLoginName(groupId, "", true);

        const options = response.data.resultObject.map(x => ({
            value: x.userEuId,
            label: x.loginName
        }));

        setUserEuIdData(options);
        setDefaultSenderOptions([{ value: "*", label: "Tüm Kullanıcılar" }, ...options]);
    };


    useEffect(() => {
        getSenderList();
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={2} pb={1}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={1} px={2} variant='gradient' bgColor='info' borderRadius='lg' coloredShadow='info'>
                                <MDTypography variant='h6' color='white'>
                                    Numara Sorgu Filtresi
                                </MDTypography>
                                <MDTypography style={{ fontSize: "13px" }} color='white'>
                                    Hesabınıza tanımlı olan kullanıcılardan Son 3 ay içerisinde giden ve raporunu görmek istediğiniz telefon numarasını sorgulayabilirsiniz.
                                </MDTypography>
                            </MDBox>
                            <MDBox pt={2} pb={2} px={2}>
                                <Grid container spacing={4}>

                                    <Grid item xs={12} md={12} lg={6}>

                                        <Grid container spacing={1} sx={style.gridStyle}>
                                            <Grid item xs={4} md={4} lg={4}>
                                                <h6>Kullanıcı Adı  : </h6>
                                                <FormHelperText>(Birden fazla kullanıcı seçimi yapabilirsiniz.)</FormHelperText>
                                            </Grid>
                                            <Grid item xs={8} md={8} lg={8}>
                                                <AsyncSelect
                                                    isMulti
                                                    cacheOptions
                                                    defaultOptions={
                                                        isAllUsersSelected
                                                            ? [{ value: "*", label: "Tüm Kullanıcılar" }]
                                                            : defaultSenderOptions
                                                    }
                                                    loadOptions={loadOptions}
                                                    menuPosition="absolute"
                                                    styles={multiSelectStyles}
                                                    placeholder="En az 2 karakter yazın"
                                                    onChange={handleUserEuIdChange}
                                                    value={userEuIdSelectedOptions}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={0} sx={style.gridStyle}>
                                            <Grid item xs={4} md={4} lg={4}>
                                                <h6>Sorgu Adı : </h6>
                                            </Grid>
                                            <Grid item xs={8} md={8} lg={8}>
                                                <MDInput
                                                    style={{
                                                        ...style.inputStyle,
                                                        border: '1px solid #ccc',
                                                        borderRadius: '6px',
                                                    }}
                                                    type='text'
                                                    value={queryName}
                                                    onChange={e => setQueryName(e.target.value)}
                                                    inputProps={{ maxLength: 100 }}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={1} sx={style.gridStyle}>
                                            <Grid item xs={4} md={4} lg={4}>
                                                <h6>Tarih : </h6>
                                            </Grid>
                                            <Grid item xs={4} md={4} lg={4}>
                                                <DatePicker
                                                    plugins={[weekends()]}
                                                    format="YYYY-MM-DD "
                                                    value={startDate}
                                                    minDate={minDate}
                                                    maxDate={maxDate}
                                                    locale={gregorian_tr}
                                                    style={{
                                                        ...style.datepickerStyle,
                                                        border: '2px solid #ccc',
                                                        borderRadius: '6px',
                                                    }}
                                                    onChange={value => setStartDate(value.format("YYYY-MM-DD HH:mm"))}
                                                />
                                            </Grid>
                                            <Grid item xs={4} md={4} lg={4}>
                                                <DatePicker
                                                    plugins={[weekends()]}
                                                    format="YYYY-MM-DD "
                                                    value={endDate}
                                                    minDate={minDate}
                                                    maxDate={maxDate}
                                                    locale={gregorian_tr}
                                                    style={{
                                                        ...style.datepickerStyle,
                                                        border: '2px solid #ccc',
                                                        borderRadius: '6px',
                                                    }}
                                                    onChange={value => setEndDate(`${value.format("YYYY-MM-DD")} 23:59:59`)}
                                                />
                                            </Grid>
                                        </Grid>

                                    </Grid>

                                    <Grid item xs={12} md={12} lg={6}>
                                        <Grid container spacing={0} sx={style.gridStyle}>
                                            <Grid item xs={4} md={4} lg={4}>
                                                <h6>Sorgulanacak Numara Türü  : </h6>
                                            </Grid>
                                            <Grid item xs={8} md={8} lg={8}>
                                                <RadioGroup row aria-labelledby='demo-row-radio-buttons-group-label' name='row-radio-buttons-group'>
                                                    <FormControlLabel value='yurtici' control={<Radio checked={numberType === "yurtici"} onClick={handleNumberTypeChange} />} label='Yurt İçi' />
                                                    <FormControlLabel value='yurtdisi' control={<Radio checked={numberType === "yurtdisi"} onClick={handleNumberTypeChange} />} label='Yurt Dışı' />
                                                    <FormControlLabel value='tckn' control={<Radio checked={numberType === "tckn"} onClick={handleNumberTypeChange} />} label='TCKN' />
                                                </RadioGroup>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={0} sx={style.gridStyle}>
                                            <Grid item xs={4} md={4} lg={4}>
                                                <h6>{phoneLabel}  : </h6>
                                                <FormHelperText>{phoneHelperText}</FormHelperText>
                                            </Grid>
                                            <Grid item xs={8} md={8} lg={8}>
                                                <TextField multiline maxRows={5} minRows={4}
                                                    value={phoneNumbersText}
                                                    style={{ border: '2px solid #ccc', borderRadius: '6px', }}
                                                    onChange={handlePhoneChange}
                                                    variant="standard"
                                                    inputProps={{ maxLength: 2000 }} />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={0} sx={style.gridStyle}>
                                        <Grid item xs={12} md={12} lg={12}>
                                            <Button style={style.buttonStyle} onClick={insertQuery}>
                                                Sorgu Talebi Oluştur
                                            </Button>
                                        </Grid>
                                    </Grid>

                                    {showAlert ? <Grid container spacing={0} sx={style.gridStyle}>
                                        <Grid item xs={12} md={12} lg={12}>

                                            <Alert
                                                severity="success"
                                                sx={{
                                                    marginLeft: "30px",
                                                    backgroundColor: "#d8f4da",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexWrap: "wrap",
                                                    gap: "4px"
                                                }}
                                            >
                                                Sorgunuz <b>{queryId}</b> id si ile işleme alınmıştır.
                                                <b>Sorgular</b> ekranından görüntüleyebilirsiniz.
                                                <Button
                                                    size="small"
                                                    sx={{
                                                        marginLeft: "10px",
                                                        marginRight: "6px",
                                                        textTransform: "none",
                                                        fontWeight: 600,
                                                        fontSize: "12px",
                                                        color: "#000",
                                                        backgroundColor: "#bfe8c6",
                                                        border: "1px solid #6fbf7f",
                                                        borderRadius: "8px",
                                                        padding: "2px 10px",
                                                        minHeight: "26px",

                                                        "&:hover": {
                                                            backgroundColor: "#aee0b7"
                                                        }
                                                    }}
                                                    onClick={() => navigate("/Sorgular", { state: { queryId } })}
                                                >
                                                    Sorguyu Aç
                                                </Button>
                                            </Alert>
                                        </Grid>
                                    </Grid> : ""}

                                </Grid>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Dialog open={msgContentDialogOpen} fullWidth={true} maxWidth='md'>
                <DialogContent>
                    <MDBox pt={3} pb={1}>
                        {msgContent}
                    </MDBox>
                </DialogContent>
                <DialogActions>
                    <Button onClick={e => { setMsgContentDialogOpen(false) }} color='primary' autoFocus>
                        Kapat
                    </Button>
                </DialogActions>
            </Dialog>
        </DashboardLayout>
    );
}

export default PhoneSearch;